interface InitializeEditModeProps {
  DepartmentListingArray: any[]
  DefaultDepartmentPolicy?: boolean
  EditData: any
  SetValue: any
  MountDefVal: boolean
}

export class DefaultDepartmentHandlerService {
  static InitializeDepartmentValueInEditMode(props: InitializeEditModeProps) {
    const {
      DepartmentListingArray,
      DefaultDepartmentPolicy,
      EditData,
      SetValue,
      MountDefVal,
    } = props

    if (!!DefaultDepartmentPolicy && DefaultDepartmentPolicy === true) {
      const isDefaultChecking = !!(
        DepartmentListingArray?.length === 1 &&
        !!DepartmentListingArray[0]?.IsDefault
      )

      if (isDefaultChecking === true) {
        SetValue('CostCentreID', DepartmentListingArray[0]?.CostCentreID)
      }
    }

    // MOUNTDEFVAL BLOCKER IS IMPORTANT TO AVOID OVERRIDING
    if (!!EditData?.CostCentreID && MountDefVal === true) {
      SetValue('CostCentreID', EditData?.CostCentreID)
    }
  }
}
